<template>
  <div>
    <div class="md-layout" v-if="false">
      <md-button class="md-dense md-primary" v-on:click="botao_voltar" v-if="botao_voltar_visible">
        <md-icon>arrow_back</md-icon>Voltar para lista
      </md-button>
    </div>
    <div class="md-layout" v-if="show_message == 'on' ">
      <div class="alert alert-success">{{message_text}}</div>
    </div>

    <div class="md-layout" v-if="loading">
      <div class="md-layout-item md-size-100">
        <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        {{msg_status}} ..
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Dados Básicos</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Nome</label>
              <div class="md-layout-item">
                <md-field>
                  <md-input
                    v-model="form.nome"
                    type="text"
                    name="nome"
                    v-on:change="changed('name')"
                    v-on:keyup="indicateErrors"
                    maxlength="300"
                  ></md-input>
                  <span class="md-helper-text">Nome do cliente</span>
                </md-field>
                <span class="error_input">{{ getErrors('nome') }}</span>
              </div>
            </div>
            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Razão Social</label>
              <div class="md-layout-item">
                <md-field>
                  <md-input v-model="form.razaosocial" type="text" maxlength="300"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">CNPJ</label>
              <div class="md-layout-item">
                <md-field>
                  <!-- <the-mask  v-model="form.cnpj" :mask="['###.###.###-##', '##.###.###/####-##']"  
                class="md-input"
                 name="cnpj" v-on:change="changed('cnpj')"  v-on:keyup="indicateErrors"  maxlength="18" />
                  -->

                  <md-input
                    v-model="form.cnpj"
                    type="text"
                    name="cnpj"
                    v-mask="'##.###.###/####-##'"
                    v-on:change="changed('cnpj')"
                    v-on:keyup="indicateErrors"
                    maxlength="18"
                  ></md-input>
                </md-field>
                <span class="error_input">{{ getErrors('cnpj') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Ramo Atividade</label>
              <div class="md-layout-item">
                <md-field>
                  <md-input v-model="form.ramo_atividade" type="text" maxlength="300"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Inscrição Estadual</label>
              <div class="md-layout-item">
                <md-field>
                  <md-input v-model="form.inscricao_estadual" type="text" maxlength="30"></md-input>
                </md-field>
              </div>
            </div>
            <br />
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Contato Principal</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Fone</label>
              <div class="md-layout-item">
                <md-field>
                  <md-input v-model="form.fone" type="text" maxlength="15"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Celular</label>
              <div class="md-layout-item">
                <md-field>
                  <md-input v-model="form.celular" type="text" maxlength="15"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">E-mail</label>
              <div class="md-layout-item">
                <md-field>
                  <md-input
                    v-model="form.email"
                    type="text"
                    maxlength="300"
                    name="email"
                    v-on:change="changed('email')"
                    v-on:keyup="indicateErrors"
                  ></md-input>
                </md-field>
                <span class="error_input">{{ getErrors('email') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Site</label>
              <div class="md-layout-item">
                <md-field>
                  <md-input v-model="form.site" type="text" maxlength="300"></md-input>
                </md-field>
              </div>
            </div>
          </md-card-content>
          <br />
        </md-card>
      </div>

      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Endereço</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Logradouro</label>
              <div class="md-layout-item md-size-60 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.endereco" type="text" maxlength="300"></md-input>
                </md-field>
              </div>

              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Número:</label>
              <div class="md-layout-item md-size-10 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.numero" type="text" maxlength="10"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Bairro</label>
              <div class="md-layout-item md-size-40 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.bairro" type="text" maxlength="300"></md-input>
                </md-field>
              </div>

              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Complemento</label>
              <div class="md-layout-item md-size-30 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.complemento" type="text" maxlength="100"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Cidade</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.cidade" type="text" maxlength="300"></md-input>
                </md-field>
              </div>
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Estado</label>

              <div class="md-layout-item md-size-10 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.estado" type="text" maxlength="2"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">CEP</label>
              <div class="md-layout-item md-size-40 md-xsmall-size-70">
                <md-field>
                  <md-input v-model="form.cep" type="text" maxlength="8"></md-input>
                </md-field>
              </div>
            </div>
            <br />
            <br />
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Logo</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <filelogo :image_url="form.logo" tipo="clientes" :onChange="change_file"></filelogo>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-size-100">
        <div class="btn-right">
          <md-button
            class="md-info"
            type="button"
            v-bind:disabled="disableButton"
            v-on:click="salvar()"
          >Salvar</md-button>

          <md-button
            class="md-danger"
            type="button"
            v-bind:disabled="disableButton"
            v-if="form != null && form.id != null && form.id !='' && parseInt(form.id) > 0"
            v-on:click="excluir()"
          >Excluir</md-button>
        </div>
      </div>

      <div
        v-if="form != null && form.id != null && form.id != '' "
        class="md-layout-item md-size-100"
      >
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">
                Contatos
                <md-icon>perm_contact_calendar</md-icon>
              </h4>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <div style="text-align: right">
                  <md-button
                    @click="show_modal_contacts = true"
                    class="md-round md-just-icon md-info"
                    type="button"
                  >
                    <md-icon>edit</md-icon>
                  </md-button>
                </div>
              </div>
              <div class="md-layout-item md-size-100">
                <comp_contatos_list v-if="show_sub_form" :id_pai="form.id" tabela="cliente"></comp_contatos_list>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <modal
        v-if="form != null && form.id != null && form.id != '' && show_modal_contacts"
        @close="show_modal_contacts = false"
      >
        <div slot="body">
          <comp_contatos_cad
            :onPreSave="onPreSaveContatos"
            :onSave="onPosSaveContatos"
            :id_pai="form.id"
            tabela="cliente"
          ></comp_contatos_cad>
        </div>
      </modal>

      <md-dialog :md-active.sync="showDialogError">
        <md-tabs md-dynamic-height>
          <md-tab md-label="Erros">
            <ul class="list-group" v-if="p_validator.errors != null ">
              <li
                v-for="(item, index) in p_validator.errors"
                class="list-group-item"
                :key="index"
                style="text-align: left"
              >{{item.msg}}</li>
            </ul>
            <center>
              <md-button class="md-danger" type="button" @click="hideModal">OK</md-button>
            </center>
          </md-tab>
        </md-tabs>
      </md-dialog>

      <!-- :md-active.sync="showDialog"
        <md-modal ref="myModalRef" hide-footer title="Erros">
      <div class="d-block text-center">
        <ul class="list-group" v-if="p_validator.errors != null ">
          <li v-for="(item, index) in p_validator.errors" class="list-group-item" :key="{index}" style="text-align: left">{{item.msg}}</li>
        </ul>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="hideModal">OK</b-button>
    </md-modal>
      -->
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/validate.css";
</style>
<script>
import service from "../../../services/ClienteService";
import serviceCadastro from "../../../services/CadastroBasicoService";
import autocomplete from "../../../components/Rend/autocomplete";
import filelogo from "../../../components/Rend/filelogo";
//import contatos from '../../components/contatos';
import mixin_validator from "../../../library/mixin/validator";
import mixin_util from "../../../library/mixin/util";
import comp_contatos_list from "../contatos/comp_contatos_list";
import comp_contatos_cad from "../contatos/comp_contatos_cad";
import modal from "../../../components/Modal";

export default {
  components: {
    autocomplete,
    filelogo,
    comp_contatos_list,
    modal,
    comp_contatos_cad
  },

  mixins: [mixin_util, mixin_validator],
  props: ["id_load", "show_back_button", "onBack", "onSave"],
  data() {
    return {
      acao: "Cadastrar",
      form: {},
      perfis: [],
      clientes: [],
      clientes_list: [],

      show_perfil: false,
      file_upload: null,

      botao_voltar_visible: true,

      loading: true,

      result2: "",
      disableButton: false,

      show_message: "off",
      message_text: "",
      message_type: "success",
      interval_message: null,
      showDialogError: false,

      msg_status: "Carregando",

      show_modal_contacts: false,
      show_sub_form: true
    };
  },

  mounted() {
    let self = this;
    this.form = service.getModel();

    this.configureMessages();

    if (this.show_back_button != null && this.show_back_button != undefined) {
      this.botao_voltar_visible = this.show_back_button;
    }

    this.disableButton = true;

    if (
      this.id_load != null &&
      this.id_load != undefined &&
      this.id_load != ""
    ) {
      service.getById(this.id_load).then(function(response) {
        self.form = response.data.data;
        self.ajusta_cep();

        self.loading = false;
        self.disableButton = false;
      });
    } else {
      this.loading = false;
      this.disableButton = false;
    }

    this.$store.dispatch("setButtonBack", {
      in_form: true,
      rota: "clientes",
      exibe: this.show_back_button,
      onBack: this.onBack
    });
    //this.$store.dispatch("user/save", this.tmpUser)
  },
  methods: {
    botao_voltar() {
      var self = this;

      if (this.onBack != null && this.onBack != undefined) {
        console.log("clique no voltar!");
        this.onBack(self);
      }
    },
    ajusta_cep() {
      if (this.form.cep_str != null && this.form.cep_str.length > 1) {
        this.form.cep = this.form.cep_str.replace("#", "");
      }
    },
    changed(prop) {},

    getClientes(searchTerm) {
      let self = this;
      this.clientes = new Promise(resolve => {
        return serviceCliente
          .getList(searchTerm, "nome", "asc")
          .then(function(response) {
            resolve(response.data);
          });
      });
    },
    configureMessages() {
      const dict = {
        // email: {
        //   required: 'O e-mail não pode ser vazio!',
        //   email: 'É necessário informar um e-mail válido!'
        // },
        nome: {
          required: "Nome não pode ser vazio!"
        }
        // cnpj: {
        //   required: 'CPF/CNPJ não pode ser vazio!',
        // cpf: true //testará o método de CPF
        // }
      };

      this.setFieldsValidator(dict);

      //this.p_validator.localize('en', dict);
    },
    onPreSaveContatos() {
      this.show_sub_form = false;
    },
    onPosSaveContatos(itens) {
      this.show_sub_form = true;
    },
    salvar() {
      var self = this;

      if (!this.validar()) return false;

      self.msg_status = "Salvando..";
      self.loading = true;

      if (this.form["nome"] == null) {
        alert("Dado indo inválido!");
        return;
      }
      //
      service
        .salvar(this.form, this.file_upload)
        .then(function(response) {
          var retorno = response.data;

          self.show_message = "on";
          self.message_text = "Cliente salvo com sucesso!";

          self.interval_message = setInterval(self.clear_message, 6000);

          var item = retorno.item;

          self.msg_status = "Carregando..";
          self.loading = false;

          self.form = item;

          self.ajusta_cep();

          if (self.file_upload != null) {
          }

          if (self.onSave != null && self.onSave != undefined) {
            self.onSave(retorno, "save");
          }
        })
        .catch(function(error) {});
    },

    excluir() {
      let self = this;
      self.msg_status = "Excluindo..";
      self.loading = true;

      var fn_return = function(response) {
        var retorno = response.data;
        if (self.onSave != null && self.onSave != undefined) {
          self.onSave(retorno, "delete");
        }
        self.msg_status = "Carregando..";
        self.loading = false;
        self.botao_voltar();
      };
      if (this.form.id == null) return false;

      service.delete(this.form.id).then(fn_return);
      //	obj_api.call_delete("cliente", this.id, fn_return);
    },
    clear_message() {
      this.show_message = "off";
      clearInterval(this.interval_message);
    },
    hideModal() {
      this.showDialogError = false;
    },
    validar() {
      this.indicateAllErrors(); //Verifica todos os possíveis erros em tela.
      console.log("erros? ");
      console.log(this.p_validator.errors);

      if (this.p_validator.errors.length > 0) {
        this.showDialogError = true;
        return false;
      }

      return true;
    },
    change_file(event) {
      this.file_upload = event.target.files[0];
    }
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio /deep/ .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.form-control-static {
  margin-top: 6px;
}
</style>
